import * as React from 'react';
const classNames = require('classnames');
require('./style.css');

const PORTALINPUT_USAGE = {
	portal: '',
	admin: 'portalInputAdmin',
};

interface IProps {
	usage?: 'portal' | 'admin';
	name?: string;
	placeholder?: string;
	type: string;
	autoFocus?: boolean;
	value?: any;
	onChangeAction?: any;
	onKeyPressAction?: any;
}

/**
 *
 * @param props
 */
export const PortalInput = (props: IProps) => {
	const usage = props.usage ? PORTALINPUT_USAGE[props.usage] : PORTALINPUT_USAGE.portal;
	return (
		<input
			className={classNames('portalInput', usage)}
			type={props.type}
			placeholder={props.placeholder}
			name={props.name}
			autoFocus={props.autoFocus}
			value={props.value}
			onChange={(e) => {
				if (props.onChangeAction) {
					props.onChangeAction(e);
				}
			}}
			onKeyPress={(e) => {
				if (props.onKeyPressAction) {
					props.onKeyPressAction(e);
				}
			}}
		/>
	);
};
